import { graphql, useStaticQuery } from "gatsby";

export type Props = {
  allWpLedigtJobb: {
    nodes: {
      uri: string;
      title: string;
      ledigaJobbInfo: {
        deadline: string;
        location: string;
      };
    }[];
  };
};

export const useJobListData = () => {
  const { allWpLedigtJobb }: Props = useStaticQuery(
    graphql`
      {
        allWpLedigtJobb {
          nodes {
            uri
            title
            ledigaJobbInfo {
              deadline
              location
            }
          }
        }
      }
    `
  );
  return allWpLedigtJobb.nodes;
};
